export default __webpack_public_path__ + "static/media/mikeam.bd07019e.jpeg";